export const getParticipantsByStatusQuery = `
query getParticipantsByStatusQuery($status: OrderStatus!) {
  getParticipantsByStatus(status: $status) {
    participantId
  }
}`;

export const getListConfirmedOrdersQuery = `
query ListConfirmedOrders($sequencer: String) {
    listConfirmedOrders(sequencer: $sequencer) {
        participantId
    }
}`;

export const getListSequencersQuery = `
query listSequencers {
    listSequencers
}`;

export const getStorageBoxesQuery = `
query searchSampleBoxes($searchTerm: String!) {
  searchSampleBoxes(searchTerm: $searchTerm) {
    boxBarcode
    shelfPosition
    samples {
      sampleBarcode
      sequencer
    } 
    locked
    createdTs
    sequencer
  },
}
`;

export const getOrderByOrderNumberQuery = `
query getOrderByOrderNumberQuery($status: OrderStatus!, $orderNo: Int!) {
  getOrderByOrderNumber(status: $status, orderNo: $orderNo) {
    postcode
    sampleBarcode
    sampleLinkTs
    sequencer
  }
}`;

export const getSampleExportStatusQuery = `
query getSampleExportStatusQuery {
  getSampleExportStatus {
    createdTs
    exportLink
    jobError
    jobStatus
    runId
    updatedTs
  }
}`;

export const getDailyDispatchCountQuery = `
query getDailyDispatchCountQuery {
  getDailyDispatchCount {
    count
  }
}
`;

export const getShippingQuery = `
  query getStagedShipmentQuery {
    getStagedShipment {
      sampleBoxes {
        barcode
        count
        shelfPosition
        sequencer
      }
      sequencer
      totalSampleCount
      shipmentId
      createdTs
    }
  }
`;

export const getStorageBoxQuery = `
  query getStorageBoxQuery($boxBarcode: String!) {
    getStorageBox(boxBarcode: $boxBarcode) {
      boxBarcode
      shelfPosition
      sequencer
      samples {
        sampleBarcode
        participantWithdrawn
        samplePosition
        sequencer
      }
      locked
    }
  }
  `;

export const getShipmentManifestQuery = `
  query getShipmentManifestQuery($shipmentId: String!) {
    getShipmentManifest(shipmentId: $shipmentId) {
      link
    }
  }
  `;

export const getStagedManifestQuery = `
  query getStagedManifestQuery {
    getStagedManifest {
      Sample_ID
      Sex
      Sample_Position
      Consent_version
      Matrix_Rack
    }
  }
  `;

export const getShippingHistoryQuery = `
  query listShipmentsQuery {
    listShipments {
      sampleBoxes {
        barcode
        count
        shelfPosition
      }
      totalSampleCount
      shipmentId
      createdTs
    }
  }
  `;

export const getParticipantSampleByBarcodeQuery = `
  query getParticipantSampleByBarcodeQuery($barcode: String!) {
    getParticipantSampleByBarcode(barcode: $barcode) {
      sampleBarcode
      sequencer
    }
  }
  `;
